import Aura from '@primeuix/themes/aura';

/**
 * Aura supplies PrimeNG's component structure. Brand colours, typography,
 * radii and shadows are mapped from CSS tokens in sass/theme/primeng-mapping.
 */
export function resolveAppPreset() {
  return Aura;
}
